export const SET_CERTIFICADOS_PUE_STATE = 'SET_CERTIFICADOS_PUE_STATE'
export const SET_CONDICIONES_CERTIFICADOS_PUE_STATE = 'SET_CONDICIONES_CERTIFICADOS_PUE_STATE'
export const SET_CERTIFICADOS_PUE_CART_STATE = 'SET_CERTIFICADOS_PUE_CART_STATE'